import {
  ClipboardList,
  Globe,
  Heart,
  MoreHorizontal,
  Sparkles,
  User,
  type LucideIcon,
} from 'lucide-react';
import type { QuestionCategoryCount } from '@/types/dashboard.ts';
import type { QuestionCategory } from '@/types/messages.ts';

/** What each leadership domain is called on screen, and the mark beside it. */
export const CATEGORY_META: Record<
  QuestionCategory,
  { title: string; Icon: LucideIcon }
> = {
  task_oriented: { title: 'Task-Oriented Leadership', Icon: ClipboardList },
  relationship_oriented: { title: 'Relationship-Oriented Leadership', Icon: Heart },
  change_oriented: { title: 'Change-Oriented Leadership', Icon: Sparkles },
  external_oriented: { title: 'External Orientation', Icon: Globe },
  self_leadership: { title: 'Self-Leadership', Icon: User },
  other: { title: 'Other Topics', Icon: MoreHorizontal },
};

/**
 * Busiest domain first, with "Other Topics" pinned to the end however many
 * questions land in it — it is the bucket, not a domain that happened to win.
 */
export function sortCategories(
  categories: QuestionCategoryCount[],
): QuestionCategoryCount[] {
  return [...categories].sort((a, b) => {
    if (a.category === 'other') return 1;
    if (b.category === 'other') return -1;
    return b.count - a.count;
  });
}

/** "Updated 5m ago", from the moment the summary was generated. */
export function formatTimeAgo(isoString: string): string {
  const seconds = Math.floor((Date.now() - new Date(isoString).getTime()) / 1000);
  if (seconds < 60) return 'Updated just now';

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `Updated ${minutes}m ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `Updated ${hours}h ago`;

  return `Updated ${Math.floor(hours / 24)}d ago`;
}
